import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }


import { useThemeStore } from '@/stores/theme';
import ReturnTreasureViewOne from '@/themes/themeOne/returnTreasure/returnTreasureView.vue';
import ReturnTreasureViewTwo from '@/themes/themeTwo/returnTreasure/returnTreasureView.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'returnTreasureView',
  emits: ['getDepositClaim', 'resetShowTreasurePopup'],
  setup(__props, { emit: __emit }) {

const themeStore = useThemeStore()
const emits = __emit
const resetShowTreasurePopup = () => {
    emits('resetShowTreasurePopup')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(themeStore).themeIndex === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(ReturnTreasureViewOne, { onResetShowTreasurePopup: resetShowTreasurePopup })
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(ReturnTreasureViewTwo, {
            onGetDepositClaim: _cache[0] || (_cache[0] = () => emits('getDepositClaim')),
            onResetShowTreasurePopup: resetShowTreasurePopup
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})